var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import securityApi from "apis/eduidSecurity";
import { EduIDButton } from "components/Common/EduIDButton";
import { ToolTip } from "components/Common/ToolTip";
import { CHPASS_BASE_PATH } from "helperFunctions/paths";
import { useCallback } from "react";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router";
export function ChangePasswordDisplay() {
    const navigate = useNavigate();
    const [fetchSuggestedPassword] = securityApi.useLazyFetchSuggestedPasswordQuery();
    const handleSuggestedPassword = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        const response = yield fetchSuggestedPassword();
        if (response.isSuccess) {
            navigate(CHPASS_BASE_PATH);
        }
    }), [fetchSuggestedPassword, navigate]);
    return (_jsxs("article", { id: "change-password", children: [_jsxs("div", { className: "flex-between baseline", children: [_jsx("h2", { children: _jsx(FormattedMessage, { id: "common.changePassword", defaultMessage: "Change password", description: "Dashboard change password" }) }), _jsx(ToolTip, {})] }), _jsx("p", { children: _jsx(FormattedMessage, { id: "changePasswordDisplay.link", defaultMessage: "Click the link to change your eduID password.", description: "Dashboard change password link description text" }) }), _jsx(EduIDButton, { id: "security-change-button", buttonstyle: "link normal-case", onClick: handleSuggestedPassword, children: _jsx(FormattedMessage, { id: "common.changePassword", defaultMessage: "Change password", description: "Dashboard change password button text" }) })] }));
}
